import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Comprehensive Psychiatric Care of Connecticut theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const CPCCARE_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/cpccare/logo.png",
        alt: "Comprehensive Psychiatric Care of Connecticut Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: [28, 30],
  state: "CT",
  departmentIds: [131, 163],
};
